import { useTranslation } from "react-i18next";

export function CalendarLegend2() {
  const { t } = useTranslation();

  const items = [
    { color: "bg-[#a3e635]", label: t("Holiday") },
    { color: "bg-[#4d7c0f]", label: t("Day off") },
    { color: "bg-[#1d4ed8]", label: t("Confirmed") },
    { color: "bg-[#facc15]", label: t("Confirmed by Manager") },
    { color: "bg-[#4a5565]", label: t("Unconfirmed") },
    { color: "bg-[#a8ffa0]", label: t("holiday.Absence") },
    { color: "bg-[#ad4ae2]", label: t("holiday.HealthAbsence") },
    { color: "bg-[rgb(206_114_114_/_0.34)]", label: t("holiday.Subbed") },
  ];

  const icons = [
    { iconClass: "dx-icon-close text-red-500", label: t("Not synchronized") },
    { iconClass: "dx-icon-clock text-orange-400", label: t("Synchronizing") },
    { iconClass: "dx-icon-check text-green-500", label: t("Synchronized") },
    { iconClass: "dx-icon-clear text-black dark:text-white", label: t("holidayPopup.cancelled") },
  ];

  return (
    <div className="max-w-5xl p-3 mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-2">
          <div className={`w-4 h-4 ${item.color}`} />
          <div className="leading-none">{item.label}</div>
        </div>
      ))}
      {icons.map((item) => (
        <div key={item.label} className="flex items-center gap-2">
          <i className={item.iconClass} />
          <div className="leading-none">{item.label}</div>
        </div>
      ))}
    </div>
  );
}
